import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * PurchaseService provides purchase API services
 */
class PurchaseService {

    purchase = (request) => {
        //console.log('PurchaseService.purchase() request:', request)
        return new Promise((resolve, reject) => {
            const url = `/api/v2/purchase/accounts/${request.accountId}`
            ky.post(url, {json: request}).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

}

// Create a singleton instance of the service to export
const instance = new PurchaseService();

export default instance;